// extracted by mini-css-extract-plugin
export default {"navigation":"NavMenuProfile_navigation__hDBXc","active":"NavMenuProfile_active__iWmcN","infoButton":"NavMenuProfile_infoButton__xBvq2"};